/**
 * Business Exceptions are handled globally within HTTP_SERVICE
 *
 * Once fired, the HTTP_SERVICE returns a Promise rejection.
 * To distinguish between handled Business Exceptions and uncatched Exceptions, you can simply check the error by
 *  getAxios().request(() => { OK }, (error) => {
 *      if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
 *          // do your completion stuff but do NOT show another warning
 *      } else {
 *          // do your completion stuff AND show a warning
 *      }
 *  })
 */
export class DisguiseBusinessExceptionWrapper {
    private exception: DisguiseDto.DisguiseBusinessExceptionDto;

    constructor(exception: DisguiseDto.DisguiseBusinessExceptionDto) {
        this.exception = exception;
    }

    getException(): DisguiseDto.DisguiseBusinessExceptionDto {
        return this.exception;
    }
}
